import React from 'react'
import TextEditor from "./TextEditor";
import Dropdown from 'react-dropdown';
import Popup from "./Popup";
import db from './db';
import printJS from 'print-js'
var functions = require("./functions.js");

// NotePopup Component
export default class NotePopup extends React.Component {

    emptyNote={note_type:"note"};

    componentDidMount(prevProps) {
        this.populateLinks();
    }
    componentDidUpdate(prevProps) {
        this.populateLinks();
    }
    
    // render
    render() {
        return(true) ? (
            <div className="note-popup">
                <Popup className="note-popup" trigger={ this.props.visible }  >
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.closeNotePopup() }>x</button>
                    </div>
                    <h3>
                        Note
                        <div className='align-right'>
                            <button onClick={() => this.printNote()}>Print</button>
                        </div>
                    </h3>
                    <Dropdown
                        name="note_type" 
                        id="dropdown_note_type"
                        options={this.getNoteTypeList()} 
                        onChange={this.updateNoteTypeInputValue.bind(this)} 
                        placeholder="Select an option" 
                        value={this.props.note.note_type}
                    /> 
                    <div id="linksDiv"></div>
                    <TextEditor 
                        className="NoteTextArea"
                        label="Note"
                        name="note" id="noteEditor" 
                        onChange={this.updateNoteInputValue.bind(this)}
                        type="json"
                        defaultValue={this.props.note.note}>
                    </TextEditor>
                    <br />
                    <button disabled={!this.state.notePopupModified} className="" onClick={() => this.closeNotePopup() }>Close</button>
                    <button disabled={!this.state.notePopupModified} className="" onClick={() => this.saveNote(this) }>Save</button>               
                </Popup>

                <div className="hub-input-inner">
                    {this.props.children}
                </div>
                <form id="printarea">
                </form>
            </div>
        ) :"";
    }
    /*
    Note Popup methods
    -------------------
    */
    // update value in post
    updateNoteInputValue(evt){ 
        let notePopupPostNote = this.state.notePopupPostNote;
        notePopupPostNote.id=this.props.note.id;
        notePopupPostNote[evt.currentTarget.name] = evt.currentTarget.value;        
        this.setState({
            notePopupModified:true,
            notePopupPostNote:notePopupPostNote
        });  
    }

    // update the input type to change screen and template when users selects new note type
    updateNoteTypeInputValue(option) {

        // change note type
        let notePopupPostNote = this.state.notePopupPostNote;
        notePopupPostNote["note_type"] = option.value;        
        notePopupPostNote.id=this.props.note.id;
        // set to modified
        this.setState({
            notePopupModified:true,
            notePopupPostNote: notePopupPostNote
        });        

        // update template
        let arr=this.getNoteTypeList();

        // find correct option type in array
        arr.forEach( opt=>{
            if(opt.value===option.value){

                // if there is nothing in memo replace with template
                if(document.getElementById("noteEditor").value===""){
                    this.props.note.note = this.getTemplate(opt.template);
                    //let notePopupPostNote=this.state.notePopupPostNote;
                    let tempnote=this.getTemplate(opt.template);
                    tempnote=tempnote.replaceAll("<facility_id>",this.props.note.facility_id);
                    document.getElementById("noteEditor").value = tempnote;
                    notePopupPostNote.note=tempnote;
                    this.setState({
                        notePopupPostNote:notePopupPostNote
                    })
/*
                // if there is something in the note prompt user to change it to template
                } else if(!opt.template!==""){
                    if(window.confirm("Would you like to replace the current value with the template?")){
                        document.getElementById("noteEditor").value = opt.template;
                        this.props.note.note = opt.template;
                        //let notePopupPostNote=this.state.notePopupPostNote;
                        notePopupPostNote.note=opt.template;
                        this.setState({
                            notePopupPostNote:notePopupPostNote
                        })                        
                    }
*/
                }
            }
        })
        this.populateLinks();
    }

    // close the popup
    closeNotePopup(){
        if(this.state.notePopupModified){
            if (window.confirm("The screen has been modified.  Would you like to exit without saving changes?") === true) {
                this.closePopup();
            } 
        } else {
            this.closePopup();
        }
    }    

    closePopup(){
        this.props.onCloseNotePopup();
        this.setState({
            notePopupModified:false
        })
    }
    // save the note
    saveNote(thisApp){
        let note = this.state.notePopupPostNote;
        note.facility_id=this.props.note.facility_id;
        note.hub_id=this.props.note.hub_id;
        note.tableName=this.props.tableName;
        db.saveData( this.props.securityObject
                        , note
                        ,"api/updateNote"
                        , function(){
                            //this.setNotePopupVisible(false);
                            thisApp.setState({
                                notePopupModified:false,
                                notePopupPostNote : {}
                            }); 
                            thisApp.props.onCloseNotePopup();
                        });
    }

    // initlize the Note popup
    constructor(props) {
        super(props);
        this.state = {
            notePopupPostNote : {},
            notePopupModified : false
        }
    }
    // display a date
    static renderDateNoteDate(cellData, rowData, rowIndex){
        return functions.reactDate(rowData.note_date);
    }

    getTemplate(obj){
        if ( (typeof obj)==="string"){
            return obj;
        } else if ( (typeof obj)==="object"){
            let result="";
            obj.forEach( str =>{
                result += str+"\n";
            })
            return result;
        }
    }
    getNoteTypeList(){
        let arr=JSON.parse(this.props.securityObject.systemSettings.note_type_list);
        let result=[];
        arr.forEach( obj=>{
            if(!obj.loc){
                result.push(obj);
            } else if(obj.loc===this.props.filterLoc){
                result.push(obj);
            }
        });
        return result;
        
    }

    populateLinks(){
        try {
            let lst=this.getNoteTypeList();        
            let noteType=this.props.note.note_type;
            if(this.state.notePopupPostNote["note_type"] ){
                noteType=this.state.notePopupPostNote["note_type"] ;
            }
            let linksDiv=document.getElementById("linksDiv");
            linksDiv.innerHTML="Links: ";
            lst.forEach( opt=>{
                if(opt.value===noteType){
                    if(opt.link){
                        opt.link.forEach( link=> {
                            linksDiv.innerHTML+=`<a href="${link.link}" target="_blank">${link.desc}</a> `
                        })
                    }
                }
            })
        } catch (ex){}
    }

    printNote(){
        let  someJSONdata = [
         ]     
        let header='<h3 className="custom-h3">Wave Devices App Notes</h3>';
        if(this.props.facility_id){
            header+='Facility:'+this.props.facility.facility_name+"<br />"
        }
        if(this.props.hub.hostname){
            header+='Facility:'+this.props.hub.facility_name+"<br />"
            header+='Host Name:'+this.props.hub.hostname+'<br>'
            header+='Model:'+this.props.hub.model+'<br>'
        }        
        header+=`<pre>${this.props.note.note}</re>`;
        printJS({
            printable: someJSONdata,
            type: 'json',
            properties: [],
            header: header
            //style: '.custom-h3 { color: red; }'
          })

    }
}

